import React from "react";
import "../styles/Header.css";
import { MdMenuOpen } from "react-icons/md";
import { MdOutlineClose } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Link } from "react-router-dom";

function Header() {
  return (
    <>
      <nav
        className="navbar navbar-expand-lg py-4 py-lg-0 shadow "
        style={{ backgroundColor: "black", position:"sticky", top:"0"}}
      >
        <div className="container px-4">
          <img src="image/log.jpeg" alt="logo" />
          {/* Offcanvas Toggle Button */}
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight"
          >
            <MdMenuOpen style={{ color: "white" }} />
          </button>
          {/* Offcanvas Content */}

          <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
            style={{ backgroundColor: "black" }}
          >
            <div className="offcanvas-header">
              <img src="image/log.jpeg" alt="logo" />
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <MdOutlineClose style={{ color: "white" }} />
              </button>
            </div>

            <div className="offcanvas-body">
              <ul className="navbar-nav ms-auto p-4 p-lg-0">
                <li className="nav-item px-3 px-lg-0 py-1 py-lg-4">
                  <Link
                    className="nav-link"
                    to="/"
                    style={{
                      color: "#61eeff ",
                      textDecoration: "none",
                    }}
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item px-3 px-lg-0 py-1 py-lg-4">
                  <Link
                    className="nav-link"
                    to="/track-order"
                    style={{
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Track Order
                  </Link>
                </li>
                <li className="nav-item px-3 px-lg-0 py-1 py-lg-4">
                  <Link
                    className="nav-link"
                    to="/about"
                    style={{
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    About
                  </Link>
                </li>

                <li className="nav-item px-3 px-lg-0 py-1 py-lg-4">
                  <button
                    className="btn"
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "#61eeff",
                      color: "#000",
                    }}
                  >
                    Contact Us
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
